import { Accordion } from "@somethings-ui/web";
import { NoticeConversationRow } from "./notice-conversation-row";
import type { NoticeConversation } from "./notice-conversations";
import type {
  NoticeSupportGroupKey,
  NoticeSupportGroups,
} from "./notice-support-grouping";

const SUPPORT_GROUP_ORDER: ReadonlyArray<{
  key: NoticeSupportGroupKey;
  label: string;
}> = [
  { key: "supervisors", label: "Supervisors" },
  { key: "cohorts", label: "Cohorts" },
  { key: "groups", label: "Groups" },
  { key: "other", label: "Other" },
];

interface NoticeSupportGroupListProps {
  groups: NoticeSupportGroups;
  hideEmptyGroups?: boolean;
  selectedChannel: string | null;
  onRowOpen: (conversation: NoticeConversation, position: number) => void;
}

export function NoticeSupportGroupList({
  groups,
  hideEmptyGroups = false,
  selectedChannel,
  onRowOpen,
}: NoticeSupportGroupListProps) {
  return (
    <>
      {SUPPORT_GROUP_ORDER.map(({ key, label }) => {
        const conversations = groups[key];
        if (hideEmptyGroups && conversations.length === 0) {
          return null;
        }
        return (
          <Accordion.Item key={key} defaultOpen={conversations.length > 0}>
            <Accordion.Header>{label}</Accordion.Header>
            <Accordion.Content emptyText="No conversations">
              {conversations.map((conversation, index) => (
                <NoticeConversationRow
                  key={conversation.id}
                  conversation={conversation}
                  collapsed={false}
                  selected={selectedChannel === conversation.id}
                  showBadge={false}
                  onSelect={() => onRowOpen(conversation, index)}
                />
              ))}
            </Accordion.Content>
          </Accordion.Item>
        );
      })}
    </>
  );
}
